<!-- client/frontend/src/components/RecipeMeal.vue -->
<template>
  <div class="meal-type-selector d-flex justify-content-center">
    <button
      v-for="(mealTypeOption, i) in mealTypeOptions"
      :key="i"
      @click="selectMealType(mealTypeOption.value)"
      class="btn flex-grow-1"
      :class="
        (selectedMealType === mealTypeOption.value
          ? 'btn-secondary'
          : 'btn-outline-secondary') +
        (i < mealTypeOptions.length - 1 ? ' me-2' : '')
      "
    >
      {{ mealTypeOption.text }}
    </button>
  </div>
</template>

<script>
export default {
  name: "RecipeMeal",

  data() {
    return {
      mealTypeOptions: [
        { text: "Завтрак", value: "завтрак" },
        { text: "Обед", value: "обед" },
        { text: "Ужин", value: "ужин" },
      ],
      selectedMealType: "",
    };
  },

  mounted() {
    // Check lastviewed state in localStorage
    const lastViewedRecipe = localStorage.getItem("lastViewedRecipe");
    const obj = JSON.parse(lastViewedRecipe);
    if (obj && obj.from === "suggested") {
      localStorage.removeItem("lastViewedRecipe");
      const savedMealType = localStorage.getItem("selectedMealType");
      if (
        savedMealType &&
        this.mealTypeOptions.some((opt) => opt.value === savedMealType)
      ) {
        this.selectedMealType = savedMealType;
        console.log(
          `RecipeMeal: Restored meal type from localStorage due to 'lastViewedRecipe': ${this.selectedMealType}`
        );
        this.$emit("meal-type-selected", this.selectedMealType);
        // No need to save selectedMealType to localStorage here as it's already there
      } else {
        // Flag was set, but no saved type found or it's invalid, determine by time
        console.warn(
          "RecipeMeal: 'lastViewedRecipe' was true, but no valid 'selectedMealType' found in localStorage. Determining by time."
        );
        this.determineMealTypeByTimeAndEmit();
      }

      return;
    }

    // Normal load, determine type by time
    this.determineMealTypeByTimeAndEmit();
  },

  methods: {
    determineMealTypeByTimeAndEmit() {
      // Clear all saved recipe offsets for meal types,
      // ensuring a fresh start when not restoring a specific state.
      this.mealTypeOptions.forEach((opt) => {
        localStorage.removeItem(`cooksyRecipeOffset_${opt.value}`);
      });

      const hour = new Date().getHours();
      let mealTypeToSet;

      if (hour < 12) {
        // Before 12 AM
        mealTypeToSet = "завтрак";
      } else if (hour >= 12 && hour < 17) {
        // From 12 AM to 4:59 PM
        mealTypeToSet = "обед";
      } else {
        // From 5 PM onwards
        mealTypeToSet = "ужин";
      }
      this.selectedMealType = mealTypeToSet;
      console.log(
        `RecipeMeal: Meal type determined by time: ${this.selectedMealType}`
      );

      // Save the time-determined type so it's available on the next normal visit
      localStorage.setItem("selectedMealType", this.selectedMealType);
      this.$emit("meal-type-selected", this.selectedMealType);
    },

    selectMealType(mealType) {
      if (this.selectedMealType !== mealType) {
        this.selectedMealType = mealType;
        console.log(
          `RecipeMeal: Meal type selected by user: ${this.selectedMealType}`
        );
        // Save the user-selected type
        localStorage.setItem("selectedMealType", this.selectedMealType);
        this.$emit("meal-type-selected", this.selectedMealType);
      }
    },
  },
};
</script>

<style scoped>
/* Styles can be copied or adapted from RecipeSuggested.vue if needed,
   or kept minimal if Bootstrap classes are sufficient. */
/* .btn {} */
</style>
